import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e58271b&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=2e58271b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e58271b",
  null
  
)

export default component.exports